import Vue from 'vue'
import UploadTool from '@yxqn/oss-upload-tool'
import { Loading } from 'element-ui'

import { getOssToken } from 'api/common'

UploadTool.getTempTokenFun = getOssToken
UploadTool.defaultBusinessType = ''

function CustomLoading () {
  this.loading = null
  this.hide = () => {
    this.loading && this.loading.close()
  }

  this.show = () => {
    this.loading = Loading.service({
      lock: true,
      text: '文件上传中，请稍等',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    return this
  }
}

const customLoading = new CustomLoading()

UploadTool.defaultStartHook = customLoading.show
UploadTool.defaultEndHook = customLoading.hide
/**
 * @param options
 * @param hooks
 * @returns {UploadTool}
 */
Vue.prototype.$uploadTool = function (options = {}, hooks = {}) {
  return new UploadTool(options, hooks)
}
